export const GET_SCHOOL_VC_REPORT = "/officer/report/school-vcnode"